import baseRoute from '../baseRoute';

export type * from './requestModel';

type BaseRouteDefinition = `${typeof baseRoute}/fieldReportTypes/reports/${number | ':fieldReportTypeId'}/attachPDFToWorkOrders`;

type RouteDefinition = BaseRouteDefinition;

export const ROUTE: RouteDefinition = `${baseRoute}/fieldReportTypes/reports/:fieldReportTypeId/attachPDFToWorkOrders`;

export const URL = (fieldReportTypeId: number): RouteDefinition =>
	`${baseRoute}/fieldReportTypes/reports/${fieldReportTypeId}/attachPDFToWorkOrders`;
